import React from 'react'

import ButtonModal from '../../components/button-modal'
import CustomCarousel from '../../components/custom-carusel'
import Header from '../../components/header'
import { mockImagesSliderDesigners } from '../../data/catalogItem'

import './style.scss'

const Designers = () => {
  return (
    <>
      <Header
        isAbsolute
        showSearchIcon={false}
      />
      <div className="designers container">
        <CustomCarousel
          className="designers-slider"
          infinite={false}
          hideTextUntilActive={true}
          slides={mockImagesSliderDesigners}
          showPrevArrow={false}
        />
        <div className="designers-content">
          <ButtonModal
            className="designers-btn"
            text={'оставить заявку'}
          />
        </div>
      </div>
    </>
  )
}

export default Designers
